import React from 'react';

function Quote() {
  return (
    <div>
      <h1>
        Mathematics is not about numbers, computations,
        or algorithams: it is about understanding. -William Paul Thurston
      </h1>
    </div>
  );
}

export default Quote;
